// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3rEJW","emails":"CreateEditClinics_emails__2YCin","emailTagLabel":"CreateEditClinics_emailTagLabel__3Iryd"};